import { BOSCH_MAP_STYLES } from '../../../common/constants/google-maps-config';

export const MAP_OPTIONS: google.maps.MapOptions = {
  fullscreenControl: true,
  maxZoom: 20,
  zoom: 8,
  center: null,
  streetViewControl: false,
  scrollwheel: true,
  styles: BOSCH_MAP_STYLES,
  mapTypeControl: false,
};

export const MAP_ITEM_STYLES = {
  strokeWeight: 4,
  borderStrokeWeight: 6,
  vehicleStrokeColor: '#4b4b4b',
  vehicleStartPointWeight: 10,
  stopPathColor: '#e0e2e5', // TODO: create tailwind config that can be imported in *.ts files and use properties from it here
  stopPathColorPassed: '#0096e8', // TODO: create tailwind config that can be imported in *.ts files and use properties from it here
  pointFillColor: '#fff',
  pointStrokeColor: '#8a9097',
  polylineFillColor: '#c1c7cc',
  polylinePassedFillColor: '#8a9097',
  actionIconSize: {
    height: 60,
    width: 50,
  },
  vehicleIconSize: {
    height: 44,
    width: 44,
  },
};
